import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Droppable } from 'react-beautiful-dnd';
import './style.scss';
import SingleTask from './SingleTask';
import { openEditor, openFilter, setTaskList } from '../../redux/actions';
import {
	Button,
	CustomScrollbars,
	FixedButtons,
	Icon,
	Loader,
	ModuleHeader,
	ModuleTopBar,
} from '../../components';
import colors from '../../utils/colors';
import { useDidUpdate } from 'rooks';

function TaskListModule() {
	const state = useSelector((state) => state);
	const dispatch = useDispatch();

	//loader state - true until data is loaded
	const [initialLoading, setInitialLoading] = useState(true);

	//load more tasks on scroll
	const [tasksNumber, setTasksNumber] = useState(10);
	const [tasksLoading, setTasksLoading] = useState(false);

	const selected = state.filter.selected;
	const mobileActive = state.filter.mobileActive || state.editor.mobileActive;

	//initial loading animation
	useEffect(() => {
		const loading = setTimeout(() => {
			setInitialLoading(false);
		}, 1500);

		return () => {
			clearTimeout(loading);
		};
	}, []);

	const loadTasks = () => {
		let topics, tasks;

		topics = state.filter.topics;
		const tasksInUse =
			state.editor.test && state.editor.test.tasks.length > 0
				? state.editor.test.tasks.map((task) => task['id_pytania'])
				: [];

		if (topics && topics.length > 0) {
			//filter topics if specific topics are selected
			if (selected.topics && selected.topics.length > 0) {
				topics = topics.filter((topic) => selected.topics.includes(topic['temat_id']));
			}

			//get tasks from available topics
			tasks = topics
				.filter((topic) => topic.pytania && topic.pytania !== null)
				.reduce((acc, topic) => acc.concat(topic.pytania), []);

			// TODO: filter tasks by selected task type

			//filter tasks by selected difficulty - temporary hidden
			// tasks = tasks.filter(task => selected.difficulty.includes(task['poziom_zakres']));

			//filter out tasks, that have been already used in editor
			if (tasksInUse && tasksInUse.length > 0) {
				tasks = tasks.filter((task) => !tasksInUse.includes(task['id_pytania']));
			}

			dispatch(setTaskList(tasks));
		} else {
			dispatch(setTaskList([]));
		}
	};

	//load task on mount and whenever available topics, filters or tasks in editor have changed
	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(loadTasks, [
		state.filter.topics,
		selected.topics,
		selected.taskType,
		selected.difficulty,
		state.editor.test,
	]);

	//reset displayed tasks number to 10
	useDidUpdate(() => {
		setTasksNumber(10);
	}, [selected.level, selected.subject]);

	const parsedTasks =
		state.tasks.tasks.length > 0
			? state.tasks.tasks
					.sort((a, b) => Number(a['id_pytania']) - Number(b['id_pytania']))
					.slice(0, tasksNumber)
			: null;

	const handleLoadMoreTasks = (e) => {
		if (e.target.clientHeight + e.target.scrollTop >= e.target.scrollHeight) {
			setTasksLoading(true);
			setTimeout(() => {
				const ammount =
					parsedTasks.length + 10 < state.tasks.tasks.length
						? 10
						: state.tasks.tasks.length - parsedTasks.length;
				if (ammount > 0) {
					setTasksNumber(tasksNumber + ammount);
				}
				setTasksLoading(false);
			}, 1000);
		}
	};

	const headerTitle = initialLoading
		? 'Ładowanie zadań...'
		: `Znaleziono ${state.tasks.tasks.length} zadań`;

	const taskListPlaceholder = !(
		state.filter.selected.level || state.filter.selected.subjects.length > 0
	)
		? 'Aby wyświetlić zadania wybierz poziom nauczania i przedmiot'
		: !state.filter.selected.subjects.length > 0
		? 'Aby wyświetlić zadania wybierz przedmiot'
		: state.filter.loadingSections.includes('topics')
		? 'Pobieranie zadań...'
		: 'Nie znaleziono zadań spełniających wybrane kryteria';

	return (
		<section className={`module-taskslist`}>
			<ModuleTopBar>
				<p>Szukaj zadania</p>
			</ModuleTopBar>
			<ModuleHeader>
				<span>{headerTitle}</span>
			</ModuleHeader>
			<CustomScrollbars autoHide onScroll={handleLoadMoreTasks}>
				<Droppable droppableId={state.tasks.id} isDropDisabled={true} isCombineEnabled={true}>
					{(provided) => (
						<div className="tasklist" {...provided.droppableProps} ref={provided.innerRef}>
							{parsedTasks?.map((task, index) => (
								<SingleTask
									key={`taskslist-task-${task['id_pytania']}`}
									id={task['id_pytania']}
									task={task}
									index={index}
								/>
							))}
							{tasksLoading && (
								<div className="tasks-loader">
									<Loader type="ellipsis" />
								</div>
							)}
							{state.tasks.tasks.length <= 0 && (
								<p className="tasklist-placeholder">{taskListPlaceholder}</p>
							)}
							{provided.placeholder}
						</div>
					)}
				</Droppable>
			</CustomScrollbars>
			<footer className="tasklist-footer"></footer>
			{state.app.isTabletSize && !mobileActive ? (
				<FixedButtons>
					<Button color="white text-primary" onClick={() => dispatch(openFilter())}>
						filtruj zadania
						<Icon name="filter" width="13" height="13" />
					</Button>
					{state.app.isMobileSize && (
						<Button color="primary text-white" onClick={() => dispatch(openEditor())}>
							podgląd testu
							<Icon name="eye" width="18" height="18" color={colors.white} />
						</Button>
					)}
				</FixedButtons>
			) : undefined}
		</section>
	);
}

export default TaskListModule;
